module.exports = __webpack_public_path__ + "img/sq-bg1.a736b843.png";